import React from "react";
// react-router-dom components
import { useNavigate, useParams } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

import { withStyles, styled } from "@mui/styles";

// @mui icons
import Brightness1 from "@mui/icons-material/Brightness1";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKAlert from "components/MKAlert";

import axios from "axios";
import Config from "config";
import secureStorage from "libraries/secureStorage";

import { Typography, Box } from "@mui/material";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";

import zxcvbn from "zxcvbn";
// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import ModalNotif from "contents/components/ModalNotif";

const rules = [
  { label: "Min. 10 karakter" },
  { label: "Huruf besar" },
  { label: "Huruf kecil" },
  { label: "Angka" },
  { label: "Simbol (@#$!)" },
];

const styles = (theme) => ({
  buttons: {
    marginTop: "25px",
  },
  progress: {
    height: 10,
    borderRadius: 5,
  },
  barDefault: {
    transition: "transform 0.2s linear",
  },
  error: {
    backgroundColor: "#f44336 !important", // red
    transition: "transform 0.2s linear",
  },
  warning: {
    backgroundColor: "#ff9800 !important", // orange/yellow
    transition: "transform 0.2s linear",
  },
  success: {
    backgroundColor: "#4caf50 !important", // green
    transition: "transform 0.2s linear",
  },
  inlineRule: {
    display: "inline-flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  icon: {
    fontSize: 18,
    marginRight: 4,
  },
});

const StyledLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== "score", // ⬅️ penting agar "score" tidak dikirim ke DOM
})(({ score }) => ({
  height: 10,
  borderRadius: 5,
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: score <= 1 ? "#f44336" : score <= 3 ? "#ff9800" : "#4caf50",
  },
}));
class PasswordExpired extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      password: "",
      repassword: "",
      alert: false,
      error: [],
      success: [],

      redirect: false,

      showModal: false,
      modalTitle: "",
      modalMessage: "",
      confirmationStatus: 1,

      loggIn: true,

      score: 0,
      progressValue: 0,
      strengthText: ["Very Weak", "Weak", "Fair", "Good", "Strong"],
      buttonDisabled: true,
    };

    this.modalNotifRef = React.createRef();
  }

  componentDidMount() {}

  getBarColor = (classes) => {
    if (this.state.score <= 1) return classes.error;
    if (this.state.score <= 3) return classes.warning;
    return classes.success;
  };

  handleInput = (e) => {
    const id = e.target.id;
    // setAlert(false);
    let isError = { ...this.state.error };
    let isSuccess = { ...this.state.success };
    switch (id) {
      case "password":
        const score = zxcvbn(e.target.value).score;
        const progressValue = ((score + 1) / 5) * 10;

        this.setState({
          password: e.target.value,
          success: { ...this.state.success, password: true },
          error: { ...this.state.error, password: false },
          score,
          progressValue,
          buttonDisabled: score === 4 ? false : true,
        });
        console.log({ score, progressValue });
        break;
      case "repassword":
        if (e.target.value === password) {
          isSuccess = { ...isSuccess, repassword: true };
          isError = { ...isError, repassword: false };
        } else {
          isSuccess = { ...isSuccess, repassword: false };
          isError = { ...isError, repassword: true };
        }

        this.setState({
          repassword: e.target.value,
          success: isSuccess,
          error: isError,
        });
        break;
    }
  };

  handleBlur = (e) => {
    if (e.target.value) {
      switch (e.target.id) {
        default:
          this.setState({
            error: { ...this.state.error, [e.target.id]: false },
            success: { ...this.state.success, [e.target.id]: true },
          });
      }
    } else {
      this.setState({
        success: { ...this.state.success, [e.target.id]: false },
        error: { ...this.state.error, [e.target.id]: true },
      });
    }
  };

  handleKeydown = (e) => {
    if (e.key === "Enter") this.save();
  };

  handleSave = (e) => {
    this.save();
  };

  save = () => {};

  render() {
    const { classes } = this.props;
    const score = this.state.score;

    // const barClass = score <= 1 ? classes.error : score <= 3 ? classes.warning : classes.success;
    return (
      <>
        <ModalNotif ref={this.modalNotifRef} />
        <MKBox
          position="absolute"
          top={0}
          left={0}
          zIndex={1}
          width="100%"
          minHeight="100vh"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              bgImage &&
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />

        <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
          <Container>
            <MKBox component="section" width="100%" py={3}>
              <Card>
                <MKBox p={3}>
                  {/* Title */}
                  <Grid container item xs={12} md={12}>
                    <MKBox width="100%" display="flex" alignItems="center" flexDirection="column">
                      <MKTypography
                        mb={1}
                        variant="h5"
                        color="text"
                        fontWeight="bold"
                        textTransform="uppercase"
                      >
                        Password telah kadaluarsa, Silahkan ganti password anda!
                      </MKTypography>
                    </MKBox>
                  </Grid>

                  {/* Form */}
                  <Grid container spacing={2} mt={1} justifyContent="center">
                    <Grid item xs={10} md={10} mt={1}>
                      <MKInput
                        fullWidth
                        variant="standard"
                        type={this.state.showPassword ? "text" : "password"}
                        label="Password"
                        id="password"
                        error={this.state.error ? this.state.error.password : false}
                        // success={this.state.success ? this.state.success.password : false}
                        value={this.state.password}
                        onChange={this.handleInput}
                        onBlur={this.handleBlur}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() =>
                                  this.setState({ showPassword: !this.state.showPassword })
                                }
                              >
                                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                      <Box mt={2}>
                        <Typography variant="subtitle2" gutterBottom>
                          Aturan Password:
                        </Typography>
                        <Box display="flex" flexWrap="wrap">
                          {rules.map((rule, index) => {
                            return (
                              <Box key={index} className={classes.inlineRule}>
                                <Brightness1 className={`${classes.icon}`} />
                                <Typography variant="body2">{rule.label}</Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>

                      {this.state.password && (
                        <>
                          <Box mt={2}>
                            <StyledLinearProgress
                              variant="determinate"
                              value={40}
                              score={this.state.score}
                            />
                          </Box>
                          <Typography variant="body2" style={{ marginTop: 8 }}>
                            Strength: <strong>{this.state.strengthText[this.state.score]}</strong>
                          </Typography>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={10} md={10} mt={1}>
                      <MKInput
                        variant="standard"
                        type={this.state.showPassword ? "text" : "password"}
                        label="Re-Password"
                        id="repassword"
                        error={this.state.error ? this.state.error.repassword : false}
                        // success={this.state.success ? this.state.success.repassword : false}
                        value={this.state.repassword}
                        onChange={this.handleInput}
                        onBlur={this.handleBlur}
                        fullWidth
                      />
                    </Grid>

                    {/* Alert message */}
                    {this.state.alert ? (
                      <Grid item xs={12} md={12}>
                        <MKAlert color="warning">
                          <strong>Semua kolom harus diisi</strong>
                        </MKAlert>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {/* Button */}
                    <Grid item xs={12} md={12}>
                      <MKBox display="flex" justifyContent="center">
                        <MKButton
                          type="button"
                          variant="gradient"
                          color="info"
                          disabled={
                            !this.state.buttonDisabled &&
                            !this.state.error.password &&
                            !this.state.error.repassword
                              ? false
                              : true
                          }
                          onClick={this.handleSave}
                        >
                          SUBMIT
                        </MKButton>
                      </MKBox>
                    </Grid>
                  </Grid>
                </MKBox>
              </Card>
            </MKBox>
          </Container>
        </MKBox>
      </>
    );
  }
}

export default withStyles(styles)(PasswordExpired);
